module.exports = __webpack_public_path__ + "static/media/Twitter.2ff6cf1a.svg";